import { render, staticRenderFns } from "./modal-content-wrapper.vue?vue&type=template&id=3ac78bf2&"
import script from "./modal-content-wrapper.vue?vue&type=script&lang=ts&"
export * from "./modal-content-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./modal-content-wrapper.vue?vue&type=style&index=0&lang=scss&_scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports